/**
 * Created by Bart Decorte
 * Date: 06/02/2019
 * Time: 16:37
 */

class DirtyUnloadNotifier {
  constructor(containerSelector) {
    this.containerSelector = containerSelector;
    this.bindListeners();
  }

  bindListeners() {
    const $body = $('body');
    const $containers = $(this.containerSelector);
    $containers.on('input change', 'input, textarea, select', () =>
      this.lDataChanged()
    );
    $containers
      .on('submit', 'form', () => this.lFormSubmitted())
      .on('submit', () => this.lFormSubmitted());
  }

  lDataChanged() {
    this.bindBeforeUnload();
    return true;
  }

  lFormSubmitted() {
    const $window = $(window);
    $window.off('beforeunload');
  }

  setDirty() {
    this.bindBeforeUnload();
    return this;
  }

  bindBeforeUnload() {
    const $window = $(window);
    $window.on('beforeunload', () => true);
  }
}

export default DirtyUnloadNotifier;



// WEBPACK FOOTER //
// ./resources/assets/js/utils/DirtyUnloadNotifier.js